
<script>
    import {analyticsTrackCTA} from "../../analitics/analytics";
    import {timer} from "../../helpers/timer";

    export let Text;
    export let subText;
    export let phoneText;

    let onWorkTime = false;

    if(timer([9,20])) {
        onWorkTime = true;
    }

    function onClick(name){
        analyticsTrackCTA(name,'');
    }

    function onCall(event) {
        let node = event.target;
        let toki;
        document.querySelectorAll('iframe').forEach( item =>
                toki = item.contentWindow.document.querySelector('a[id="show-call"]')
        );
        console.log('toki',toki);
        if(toki) {
            toki.click();
            let popUp;
            popUp = document.querySelector('iframe[title="Widget Modal"]');

            console.log('popup',popUp);
            if(popUp) {
                setTimeout(() => {
                    let btn = popUp.contentWindow.document.querySelector('button[id="callButton"]');
                    let close = popUp.contentWindow.document.querySelector('a[class="toky-close"]');
                    btn.click();
                    close.click();
                },500);

                popUp.style.display = 'none';
                //popUp.style.position = 'absolute';
                /*popUp.style.top = node.getBoundingClientRect().top + window.scrollY - popUp.getBoundingClientRect().height +'px';
                popUp.style.left = node.getBoundingClientRect().left - (popUp.getBoundingClientRect().width / 2) + (node.getBoundingClientRect().width / 2) + 'px';*/
            }
        }
    }


</script>

<style  lang="scss">
    .wrapper {
        background-color: #3b84ff;
        background-image: url("https://storage.googleapis.com/cms.lobesoft.com/2019/12/be1b21ee-bg-scaled.jpg");
        background-size: auto;
        background-repeat: repeat;
        background-blend-mode: multiply;
        background-position: top;
        border-bottom-right-radius: 50px;
        * {
            color: white!important;
        }
    }
</style>

<component editor-editable="true">
    <style lang="scss">



        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 DIV.row.call-to-action {
            color: #484848;
            font-family: poppins, sans-serif;
            font-size: 1em;
            line-height: 1.65714286em;
            position: relative;
            text-align: left;
            -webkit-font-smoothing: antialiased;
            -webkit-tap-highlight-color: transparent;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 * {
            box-sizing: border-box;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 ::after {
            box-sizing: border-box;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 ::before {
            box-sizing: border-box;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
            margin-top: 0;
            margin-bottom: .5rem;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 p {
            margin-top: 0;
            margin-bottom: 1rem;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 a {
            color: #007bff;
            text-decoration: none;
            background-color: transparent;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 a:hover {
            color: #fc082b;
            text-decoration: underline;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
            margin-bottom: .5rem;
            font-weight: 500;
            line-height: 1.2;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
            font-size: 1.75rem;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .row {
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .col-lg-10 {
            position: relative;
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .col-lg-2 {
            position: relative;
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
        }

        @media (min-width: 992px) {
            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .col-lg-2 {
                -ms-flex: 0 0 16.666667%;
                flex: 0 0 16.666667%;
                max-width: 16.666667%;
            }

            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .col-lg-10 {
                -ms-flex: 0 0 83.333333%;
                flex: 0 0 83.333333%;
                max-width: 83.333333%;
            }
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn {
            display: inline-block;
            font-weight: 400;
            color: #212529;
            text-align: center;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            background-color: transparent;
            border: 1px solid transparent;
            padding: .375rem .75rem;
            font-size: 1rem;
            line-height: 1.5;
            border-radius: .25rem;
            transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        }

        @media (prefers-reduced-motion: reduce) {
            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn {
                transition: none;
            }
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:hover {
            color: #212529;
            text-decoration: none;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:focus {
            outline: 0;
            box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:disabled {
            opacity: .65;
        }

        @media print {
            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 * {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 ::after {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 ::before {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
                orphans: 3;
                widows: 3;
            }

            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 p {
                orphans: 3;
                widows: 3;
            }

            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
                page-break-after: avoid;
            }
        }

        /*! CSS Used from: http://inspirothemes.com/polo-v5.8/css/style.css*/
        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 * {
            margin: 0;
            padding: 0;
            text-decoration: none;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
            margin: 0;
            padding: 0;
            text-decoration: none;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 a {
            margin: 0;
            padding: 0;
            text-decoration: none;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
            font-family: poppins, sans-serif;
            color: #1f1f1f;
            margin: 0;
            letter-spacing: .5px;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
            font-size: 1.78571429em;
            line-height: 1.5em;
            font-weight: 500;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3:not(:last-child) {
            margin-bottom: 12px;
        }

        @media all and (max-width: 767px) {
            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 h3 {
                font-size: 1.35714286em;
                line-height: 1.85714286em;
            }

            .wrapper {
                background-position: right;
            }
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 p {
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            text-transform: none;
            line-height: 1.7;
            letter-spacing: 0;
            color: #777;
            font-family: poppins, sans-serif;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:not(.close):not(.mfp-close) {
            font-family: poppins, sans-serif;
            border-radius: 5px 5px 5px 5px;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: .5px;
            text-decoration: none;
            outline: none;
            padding: 12px 18px;
            position: relative;
            background-color: #fc082b;
            border-color: #fc082b;
            border-width: 1px;
            border-style: solid;
            color: #fff;
            -webkit-transition: all .3s;
            transition: all .3s;
            margin-bottom: 6px;
            outline: none;
            line-height: 14px;
            cursor: pointer;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:not(.close):not(.mfp-close):after {
            content: '';
            position: absolute;
            z-index: -1;
            -webkit-transition: all .3s;
            transition: all .3s;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:not(.close):not(.mfp-close):hover {
            background-color: #ff2238;
            border-color: #ff2238;
            color: #fff;
            text-decoration: none;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:not(.close):not(.mfp-close):focus {
            background-color: #ff2238;
            border-color: #ff2238;
            color: #fff;
            text-decoration: none;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:not(.close):not(.mfp-close):not(.btn-shadow):focus {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .btn:not(.close):not(.mfp-close):not(.btn-shadow):focus:active {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .call-to-action {
            position: relative;
            overflow: hidden;
            padding: 46px 50px 34px;
            margin-bottom: 40px;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .call-to-action h3 {
            margin-top: 10px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .call-to-action p {
            margin-top: 0;
        }

        .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .call-to-action a.btn {
            margin-top: 20px;
        }

        @media (max-width: 991px) {
            .C61ad8f80-d74d-315e-e1c1-bbea667917e2 .call-to-action {
                padding: 26px 12px 18px;
            }
        }

        i {
            margin-right: 0.3em!important;
        }

    </style>
    <div class="C61ad8f80-d74d-315e-e1c1-bbea667917e2 shadow-drop-center wrapper col-lg-12" editor-layout="true">
        <div class="row call-to-action" style="">
            <div class="col-lg-8">
                <h3>
                    {@html Text}
                </h3>
                <p>
                    {@html subText}
                </p>
            </div>
            <div class="col-lg-4">
                <a class="btn col-12 col-sm-auto  d-md-none" href="https://wa.me/+17864530818" on:click={()=>{ onClick('whatsapp') }}><i class="fab fa-whatsapp"></i> Whatsapp</a>
                <a class="btn col-12 col-sm-auto shadow-drop-bl-hover d-none d-md-inline-flex" href="https://web.whatsapp.com/send?phone=+17864530818" on:click={()=>{ onClick('whatsapp') }}><i class="fab fa-whatsapp"></i> Whatsapp</a>
                <a class="btn col-12 col-sm-auto shadow-drop-bl-hover" href="mailto:info@lobesoft.com" on:click={()=>{ onClick('email') }}><i class="far fa-envelope"></i> info@lobesoft.com</a>
                {#if onWorkTime}
                    <a class="btn col-12 col-sm-auto shadow-drop-bl-hover" href="https://app.toky.co/lobesoftllc" target="_blank" on:click={(event)=>{onClick('phone') }}><i class="far fa-phone"></i>{phoneText}</a>
                {/if}
            </div>
        </div>
    </div>
</component>
